import React, {useEffect} from "react";
import {useDispatch, useSelector} from 'react-redux';
import Modal from "../shared/Modal";
import PrisEditor from "../shared/PrisEditor";
import {FaEdit, FaRegTrashAlt} from "react-icons/fa";
import {refreshPris, removePrice} from "../../reducer/PriceReducer";

const PriceList = ({edit, setEdit, setPopup}) => {
  const pricesList = useSelector(state => state.price);
  
  const dispatch = useDispatch();
  
  const handleDelete = async () => {
    if (edit.delete === true) {
      dispatch(removePrice(edit.id));
      dispatch(refreshPris());
      setPopup(true);
    }
  };
  
  useEffect(() => {
    handleDelete();
  }, [edit]);
  
  
  return (
    <div className="font-jost flex flex-col gap-2 ">
      <h1 className="py-3 px-4 bg-red w-[69px] h5-jost">Pris</h1>
      <div className="grid grid-cols-3 gap-4 mq1000:grid-cols-2 max-sm:grid-cols-1">
      
      
      </div>
      <div>
        {pricesList.length === 0 && (
          <button
            className="text-base cursor-pointer text-white mq960:text-xs w-32 rounded bg-red p-2"
            onClick={() => setEdit({shown: true, type: 'pris'})}
          >
            Lägg till pris
          </button>
        )}
      </div>
      
      <div style={{width: "100%"}}>
        {pricesList?.map((pris, index) => (
          <div className="flex flex-col items-center w-full" key={index}>
            <div
              
              className="flex w-full justify-center shadow-white p-5 rounded-lg h-full overflow-hidden hover:overflow-auto mb-20"
            >
              <div
                className="body-jost text-gray prose prose-base leading-relaxed font-sans"
                dangerouslySetInnerHTML={{__html: pris.item}}
              />
            </div>
            
            <div className="flex gap-4">
              <button
                className="body-jost text-base bg-red w-auto text-center rounded p-2 flex gap-2 items-center"
                onClick={() =>
                  setEdit({
                    shown: true,
                    id: pris.id,
                    content: pris.item,
                    isEdit: true,
                    delete: false,
                  })
                }
              >
                <FaEdit/>
                Redigera pris
              </button>
              <button
                className="body-jost text-base bg-red w-auto text-center rounded p-2 flex gap-2 items-center"
                onClick={() =>
                  setEdit({
                    shown: false,
                    id: pris.id,
                    item: pris.content,
                    isEdit: false,
                    delete: true,
                  })
                }
              >
                <FaRegTrashAlt/>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
      {edit.shown && (
        <Modal>
          <PrisEditor setPopup={setPopup} setEdit={setEdit} edit={edit}/>
        </Modal>
      )}
    </div>
  );
};

export default PriceList;